function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 900 600",
    style: {
      enableBackground: "new 0 0 900 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 900,
    height: 600
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 900,
    height: 600
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3FAFF"
    },
    d: "M629.084,504.068c58.637,4.136,131.94-19.115,164.276-70.096 c13.39-21.11,22.282-48.205,12.961-71.558c-7.059-17.686-36.924-37.68-43.37-55.618c-6.536-18.189-5.609-38.677-2.254-57.799 c9.643-54.955-43.974-140.742-157.197-149.896C517.646,92.16,478.812,158.892,405.745,168 c-73.734,9.191-160.194-45.957-212.936,0c-65.501,57.075-34.763,114.206-26.791,140.936 c10.241,34.339-39.816,73.532-29.493,124.085c23.082,113.04,190.841,36.811,240.01,32.038 c49.936-4.847,99.493,9.366,148.43,20.776c48.936,11.41,100.767,19.994,148.601,4.332L629.084,504.068z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E9ECF2"
    },
    cx: 449.174,
    cy: 541.298,
    rx: 352.561,
    ry: 16.8
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M142.292,253.512l-1.065,0.12c-2.377-20.949,4.037-41.303,20.187-64.057l0.874,0.62 C146.3,212.721,139.946,232.841,142.292,253.512z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M135.544,267.539l-1.023,0.321c-12.258-39.05,8.77-70.675,30.957-96.461l0.813,0.699 C144.296,197.661,123.443,228.99,135.544,267.539z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M652.832,101.236c-24.596-12.574-45.42-15.959-65.537-10.66l-0.273-1.036 c20.386-5.373,41.453-1.96,66.298,10.741L652.832,101.236z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M671.316,102.588c-28.464-18.08-62.472-34.201-98.875-16.668l-0.465-0.966 c36.875-17.758,71.2-1.509,99.916,16.73L671.316,102.588z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5A9F"
    },
    d: "M358.779,209.701l-1.559-0.043c0.022-0.793,0.06-1.583,0.115-2.369l1.555,0.109 C358.838,208.162,358.8,208.931,358.779,209.701z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5A9F"
    },
    d: "M465.087,196.656c-0.421-1.515-0.915-3.029-1.467-4.501l1.46-0.548 c0.568,1.514,1.076,3.072,1.509,4.631L465.087,196.656z M359.43,202.692l-1.54-0.245c0.254-1.596,0.584-3.202,0.978-4.773 l1.512,0.38C359.996,199.58,359.677,201.141,359.43,202.692z M461.763,187.8c-0.679-1.417-1.431-2.821-2.232-4.173l1.341-0.795 c0.825,1.392,1.598,2.836,2.297,4.294L461.763,187.8z M361.735,193.515l-1.473-0.511c0.53-1.527,1.135-3.05,1.798-4.528 l1.423,0.638C362.838,190.551,362.25,192.031,361.735,193.515z M456.941,179.666c-0.915-1.274-1.901-2.526-2.928-3.72 l1.182-1.017c1.057,1.228,2.071,2.516,3.013,3.828L456.941,179.666z M365.608,184.881l-1.361-0.76 c0.788-1.413,1.649-2.809,2.557-4.146l1.29,0.875C367.211,182.151,366.374,183.508,365.608,184.881z M450.77,172.494 c-1.126-1.099-2.314-2.16-3.531-3.156l0.988-1.206c1.251,1.024,2.473,2.116,3.631,3.246L450.77,172.494z M370.919,177.05 l-1.21-0.984c1.021-1.254,2.109-2.479,3.235-3.641l1.12,1.085C372.969,174.64,371.911,175.831,370.919,177.05z  M443.449,166.501c-1.3-0.888-2.653-1.728-4.023-2.498l0.764-1.359c1.409,0.792,2.801,1.656,4.139,2.569L443.449,166.501z  M377.504,170.258l-1.021-1.179c1.225-1.061,2.509-2.078,3.818-3.024l0.914,1.263 C379.944,168.238,378.695,169.227,377.504,170.258z M435.199,161.865c-1.434-0.648-2.912-1.241-4.395-1.761l0.516-1.471 c1.526,0.535,3.047,1.145,4.522,1.812L435.199,161.865z M385.168,164.715l-0.799-1.339c1.389-0.83,2.832-1.607,4.287-2.31 l0.679,1.404C387.92,163.153,386.518,163.909,385.168,164.715z M426.271,158.735c-1.525-0.388-3.085-0.713-4.636-0.965 l0.25-1.539c1.596,0.26,3.201,0.594,4.77,0.993L426.271,158.735z M393.683,160.598l-0.552-1.458 c1.513-0.573,3.069-1.086,4.627-1.524l0.423,1.501C396.666,159.543,395.153,160.042,393.683,160.598z M416.934,157.215 c-1.569-0.114-3.161-0.161-4.732-0.138l-0.023-1.559c1.616-0.023,3.254,0.024,4.868,0.142L416.934,157.215z M402.789,158.034 l-0.29-1.532c1.59-0.301,3.216-0.537,4.819-0.701l0.158,1.551C405.917,157.511,404.336,157.741,402.789,158.034z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5A9F"
    },
    d: "M468.084,203.385l-1.544,0.22c-0.109-0.765-0.233-1.523-0.373-2.276l1.533-0.284 C467.844,201.819,467.972,202.599,468.084,203.385z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3F5A9F"
    },
    points: "363.548,210.201 357.887,212.904 352.011,210.706 358.378,224.128  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB47E"
    },
    d: "M310.395,287.345c-0.234-3.551,1.216-7.723,2.163-7.31s0.064,3.733,0.725,4.731 c0.87,1.312,1.618,2.541,0.974,5.636L310.395,287.345z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCB47E"
    },
    points: "278.394,535.148 275.563,512.272 292.335,512.272 293.071,535.148  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCA377"
    },
    d: "M292.752,525.261c-6.336,1.657-15.749-1.358-15.749-1.358l-0.666-5.431l16.24,1.366 L292.752,525.261z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCB47E"
    },
    points: "198.407,535.148 199.955,512.272 216.727,512.272 213.083,535.148  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCA377"
    },
    d: "M215.943,517.159l-1.147,7.218c-7.743,0.456-13.244-2.409-15.399-3.784l0.473-7.025 L215.943,517.159z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5A9F"
    },
    d: "M314.072,520.806c0,0-11.201-140.668-41.447-209.053l-28.118,1.41c0,0,2.4,99.042,23.495,207.643 C268.002,520.806,294.391,527.068,314.072,520.806z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5A9F"
    },
    d: "M234.396,520.806c0,0-27.671,4.473-43.456-6.262c0,0,8.405-152.521,34.145-202.53h30.264 C255.349,312.014,254.36,394.227,234.396,520.806z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#374263"
    },
    d: "M225.758,239.608c0.745-2.663,2.146-6.061,2.146-6.061c-0.49,2.549-0.499,5.369-0.447,6.894 c6.569,3.013,20.295,6.937,41.606,1.725c-0.272-2.19-0.394-4.266-0.394-4.266c0.377,1.393,0.92,2.794,1.445,4.003 c0.762-0.193,1.524-0.394,2.304-0.613c-0.639-2.707-0.911-7.41-0.911-7.41c0.745,2.829,2.216,5.711,2.838,6.858 c1.296-0.394,2.619-0.815,3.968-1.27c0,0-4.248-6.482-7.034-23.352c-2.295-13.866-9.407-20.417-20.216-20.128 c-22.231,0.596-28.161,41.851-28.161,41.851S223.849,238.592,225.758,239.608z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M302.608,288.535c0,0-8.908-40.104-44.331-42.178c-54.522-3.192-71.279,32.272-71.279,32.272 L302.608,288.535z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB47E"
    },
    d: "M246.164,206.157c6.019-3.439,16.586-3.587,19.003,4.557c2.23,7.515,1.874,30.181-8.186,29.751 c-10.516-0.449-13.834-8.443-14.772-13.328C241.872,225.382,240.145,209.596,246.164,206.157z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB47E"
    },
    d: "M242.463,226.737c0,0-4.699,1.446-5.576-2.778c-0.791-3.811,3.733-5.296,5.19-3.627 L242.463,226.737z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB47E"
    },
    d: "M307.542,336.841c6.74-13.197,12.005-44.025,12.005-44.025 c0.782-1.213,4.054-6.461,4.26-10.458c0.087-1.777-0.811-2.833-2.014-2.251c-0.432-1.444-1.289-1.707-2.446-0.862 c-0.646-1.263-1.436-1.213-2.223-0.597c-1.723-2.885-5.155,6.256-5.137,7.4c0.011,0.767,0.244,3.58,0.36,4.409 c0.154,1.096-20.212,35.806-20.212,35.806L307.542,336.841z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M196.44,517.013l-0.904-0.06c0.1-1.525,10.346-153.088,36.364-202.334l0.801,0.423 C206.772,364.118,196.54,515.489,196.44,517.013z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M218.503,287.589l-9.542,54.568c24.9,7.48,53,0.76,75.979-14.487l-9.517-53.815l-17.709-26.967 c0,0-8.635,9.853-18.152-0.224l-24.787,10.396L218.503,287.589z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M309.154,299.42l-5.028-12.468c0,0-12.583-25.579-22.937-32.194l-6.628,44.758L309.154,299.42z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#47393D"
    },
    d: "M250.348,398.193l-0.884-0.083c1.432-15.284,2.623-30.232,3.541-44.426l0.886,0.057 C252.973,367.944,251.781,382.9,250.348,398.193z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M274.715,521.122c-0.188-0.9-18.851-90.444-24.16-135.563l0.9-0.106 c5.303,45.08,23.959,134.585,24.146,135.484L274.715,521.122z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 279.744,
    y: 273.437,
    transform: "matrix(0.9848 -0.1738 0.1738 0.9848 -48.0178 53.2854)",
    style: {
      fill: "#3F5A9F"
    },
    width: 0.876,
    height: 54.65
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#374263"
    },
    d: "M238.626,219.489c0,0,1.682-0.972,3.355,0.806c0,0,0.445-3.555,1.645-5.798l0.755,3.967 c1.217,0.193,5.095,0.828,9.346,0.911c1.197,0.023,4.566,0,4.566,0l0.768-6.631l1.436,6.499 c0.99-0.079,1.759-0.184,2.547-0.289l0.562-3.898l1.086,3.67c1.06-0.175,1.796-0.342,2.155-0.42 c0.219-2.785,0.307-10.301-4.66-14.654c-5.702-4.993-17.763-2.251-20.558,3.731 C238.836,213.366,238.626,219.489,238.626,219.489z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB47E"
    },
    d: "M249.887,251.248c4.994,0,7.96-4.361,7.96-4.361l-1.251-14.443l-13.735-8.163l-3.466,22.382 C239.395,246.663,243.694,251.248,249.887,251.248z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#374263"
    },
    d: "M256.515,241.275l0.038-0.875c-6.251-0.267-10.253-5.046-12.509-9.009l-0.761,0.434 C245.648,235.979,249.863,240.991,256.515,241.275z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#374263"
    },
    d: "M274.56,545.912l42.39,0.156c1.476,0.005,2.661-1.24,2.555-2.712 c-0.001-0.018-0.003-0.036-0.004-0.054c-0.028-0.324-0.066-0.657-0.114-0.991c-0.143-1.128-0.443-2.257-0.97-2.965 c-2-2.675-5.899-3.905-12.841-6.686c-4.357-1.752-8.055-4.07-9.679-5.154c-0.528-0.355-1.215-0.269-1.678,0.17 c-8.414,8.167-13.556,6.402-15.083,3.014c-1.167-2.583-2.836-2.05-3.3-1.297c-1.421,2.358-2.221,9.278-2.548,12.748 c-0.041,0.372-0.071,0.716-0.092,0.99c-0.051,0.647-0.082,1.039-0.082,1.039 C272.954,545.073,273.648,545.909,274.56,545.912z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M303.16,537.1c3.015-1.449,2.579-4.56,2.575-4.592l-0.727,0.109 c0.015,0.106,0.35,2.61-2.166,3.819L303.16,537.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M306.876,538.362c2.775-1.553,2.49-4.253,2.476-4.367l-0.73,0.084 c0.011,0.095,0.23,2.335-2.105,3.642L306.876,538.362z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M282.957,536.427c2.836,0.01,5.408-1.273,5.45-1.295l-0.334-0.655 c-0.065,0.034-6.509,3.242-9.799-0.887l-0.575,0.458C279.145,535.863,281.107,536.42,282.957,536.427z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 290.35,
    y: 530.681,
    transform: "matrix(0.0037 -1 1 0.0037 -253.3831 831.745)",
    style: {
      fill: "#FFFFFF"
    },
    width: 0.735,
    height: 24.702
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 308.793,
    y: 540.179,
    transform: "matrix(0.0037 -1 1 0.0037 -235.079 850.2506)",
    style: {
      fill: "#FFFFFF"
    },
    width: 0.735,
    height: 5.842
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#374263"
    },
    d: "M195.175,545.912l42.39,0.156c1.476,0.005,2.661-1.24,2.554-2.712 c-0.001-0.018-0.003-0.036-0.004-0.054c-0.028-0.324-0.066-0.657-0.114-0.991c-0.143-1.128-0.443-2.257-0.97-2.965 c-2-2.675-5.899-3.905-12.841-6.686c-4.357-1.752-8.055-4.07-9.679-5.154c-0.528-0.355-1.215-0.269-1.678,0.17 c-8.414,8.167-13.556,6.402-15.083,3.014c-1.167-2.583-2.836-2.05-3.3-1.297c-1.421,2.358-2.221,9.278-2.547,12.748 c-0.041,0.372-0.071,0.716-0.092,0.99c-0.051,0.647-0.082,1.039-0.082,1.039 C193.57,545.073,194.263,545.909,195.175,545.912z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M223.776,537.1c3.015-1.449,2.579-4.56,2.575-4.592l-0.727,0.109 c0.015,0.106,0.35,2.61-2.166,3.819L223.776,537.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M227.492,538.362c2.775-1.553,2.49-4.253,2.476-4.367l-0.73,0.084 c0.011,0.095,0.23,2.335-2.105,3.642L227.492,538.362z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M203.572,536.427c2.836,0.01,5.408-1.273,5.45-1.295l-0.334-0.655 c-0.065,0.034-6.509,3.242-9.799-0.887l-0.575,0.458C199.761,535.863,201.723,536.42,203.572,536.427z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 210.965,
    y: 530.681,
    transform: "matrix(0.0037 -1 1 0.0037 -332.4749 752.361)",
    style: {
      fill: "#FFFFFF"
    },
    width: 0.735,
    height: 24.702
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 229.408,
    y: 540.179,
    transform: "matrix(0.0037 -1 1 0.0037 -314.17 770.8666)",
    style: {
      fill: "#FFFFFF"
    },
    width: 0.735,
    height: 5.842
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D92F0"
    },
    d: "M220.362,403.398l141.594-22.357c2.915-0.46,4.923-3.222,4.463-6.136l-14.388-91.127 c-0.46-2.915-3.222-4.923-6.136-4.463L204.3,301.671c-2.915,0.46-4.923,3.222-4.463,6.136l14.388,91.127 C214.686,401.85,217.447,403.858,220.362,403.398z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M248.347,366.407l-25.49,4.025c-0.789,0.125-1.537-0.419-1.662-1.209l-0.774-4.899 c-0.125-0.789,0.419-1.537,1.209-1.662l25.49-4.025c0.789-0.125,1.537,0.419,1.662,1.209l0.773,4.899 C249.68,365.535,249.136,366.283,248.347,366.407z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M282.04,361.087l-25.49,4.025c-0.789,0.125-1.537-0.419-1.662-1.209l-0.773-4.899 c-0.125-0.79,0.419-1.537,1.209-1.662l25.49-4.025c0.789-0.125,1.537,0.419,1.662,1.209l0.773,4.899 C283.373,360.215,282.829,360.963,282.04,361.087z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M315.732,355.768l-25.49,4.025c-0.789,0.125-1.537-0.419-1.662-1.209l-0.773-4.899 c-0.125-0.789,0.419-1.537,1.209-1.662l25.49-4.025c0.789-0.125,1.537,0.419,1.662,1.209l0.774,4.899 C317.066,354.895,316.522,355.643,315.732,355.768z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M349.425,350.448l-25.49,4.025c-0.789,0.125-1.537-0.419-1.662-1.209l-0.774-4.899 c-0.125-0.789,0.419-1.537,1.209-1.662l25.49-4.025c0.789-0.125,1.537,0.419,1.662,1.209l0.774,4.899 C350.758,349.575,350.214,350.323,349.425,350.448z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M351.513,365.696l-33.535,5.295c-0.961,0.152-1.871-0.51-2.022-1.471l-0.675-4.276 c-0.152-0.961,0.51-1.871,1.471-2.023l33.535-5.295c0.961-0.152,1.871,0.51,2.023,1.471l0.675,4.276 C353.136,364.634,352.474,365.544,351.513,365.696z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M221.588,329.71l-1.611-10.204c-0.352-2.23,1.176-4.331,3.406-4.683l19.822-3.13 c2.23-0.352,4.331,1.176,4.683,3.406l1.611,10.204c0.352,2.23-1.176,4.331-3.406,4.683l-19.822,3.13 C224.041,333.468,221.94,331.94,221.588,329.71z M223.554,315.909c-1.632,0.258-2.749,1.795-2.492,3.426l1.611,10.204 c0.258,1.632,1.795,2.749,3.426,2.492l19.823-3.13c1.632-0.258,2.749-1.794,2.492-3.426l-1.611-10.204 c-0.258-1.632-1.795-2.749-3.426-2.492L223.554,315.909z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 354.312,
    y: 290.348,
    transform: "matrix(0.9878 -0.156 0.156 0.9878 -42.6644 59.0245)",
    style: {
      fill: "#2E4882"
    },
    width: 1,
    height: 22.101
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M281.757,394.21l-0.156-0.988l80.277-12.675c1.278-0.201,2.404-0.894,3.171-1.947 c0.767-1.055,1.078-2.34,0.876-3.617l-6.976-44.184l0.987-0.156l6.976,44.184c0.244,1.542-0.131,3.091-1.055,4.361 c-0.924,1.271-2.282,2.104-3.823,2.348L281.757,394.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 237.953,
    y: 397.743,
    transform: "matrix(0.9877 -0.1561 0.1561 0.9877 -59.0683 44.3796)",
    style: {
      fill: "#2E4882"
    },
    width: 30.104,
    height: 1.001
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB47E"
    },
    d: "M322.708,280.023c0.621,0.189,0.935,0.883,0.659,1.472c-0.495,1.057-1.312,2.163-1.885,2.2 c-1.012,0.065-0.501-1.665-0.11-2.957C321.544,280.17,322.141,279.85,322.708,280.023L322.708,280.023z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB47E"
    },
    d: "M320.975,279.999c0.417,0.283,0.589,0.813,0.411,1.284c-0.445,1.175-1.401,2.871-2.364,2.72 c-0.612-0.096-0.206-1.935,0.194-3.43C319.41,279.849,320.354,279.578,320.975,279.999L320.975,279.999z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB47E"
    },
    d: "M318.454,279.376c0.579,0.121,0.955,0.682,0.839,1.262c-0.249,1.245-0.883,2.884-2.173,3.346 c-1.106,0.397-0.475-2.229-0.08-3.843c0.138-0.566,0.698-0.915,1.268-0.796L318.454,279.376z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB47E"
    },
    d: "M316.393,277.991c1.051,0.184,1.197,1.232,0.926,1.924c-0.495,1.264-1.359,2.697-2.154,2.892 c-0.851,0.21-0.379-1.905-0.102-3.523C315.188,278.555,315.747,277.878,316.393,277.991z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M208.533,335.112c0,0-16.568-24.265,9.076-41.559l14.689-41.311l0.001-0.276 c-17.202-0.087-35.69,10.437-45.701,25.187c-16.741,24.665-15.058,54.158,12.971,69.365L208.533,335.112z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3F5A9F"
    },
    points: "216.936,298.726 216.047,298.552 218.549,285.842 219.438,286.016  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5A9F"
    },
    d: "M205.695,346.915c-12.079-6.553-19.96-16.169-22.793-27.809 c-3.231-13.277,0.2-28.268,9.663-42.208l0.749,0.509c-9.316,13.727-12.702,28.46-9.532,41.485 c2.77,11.384,10.497,20.799,22.344,27.227L205.695,346.915z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCB47E"
    },
    d: "M206.964,337.11c0.84,0.673,3.463,2.926,4.524,3.108c0.984,0.168,6.417,0.395,6.265,1.543 c-0.16,1.203-3.866,0.268-3.83,1.238c0.022,0.598,7.257,2.55,6.529,3.817c-0.478,0.831-4.698-0.947-4.784-0.425 c-0.079,0.485,5.578,1.592,4.932,2.859c-0.677,1.328-6.121-2.019-6.398-1.389c-0.137,0.312,6.473,2.687,5.918,3.708 c-0.742,1.365-5.818-1.997-6.21-1.403c-0.193,0.292,1.813,1.159,2.941,1.826c0.625,0.37,0.428,0.934-0.065,0.912 c-5.108-0.228-11.516-6.441-12.334-6.733c-1.217-0.435-2.398-0.887-3.545-1.357L206.964,337.11z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5A9F"
    },
    d: "M207.131,304.879l-0.783-0.456c2.43-4.175,6.134-7.959,11.008-11.246l0.506,0.751 C213.102,297.138,209.492,300.822,207.131,304.879z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AADE5"
    },
    d: "M747.121,254.261c0.01,0.348,0.019,0.688,0.029,1.036 c1.247,42.527-3.117,75.676-10.502,101.506l-21.914,13.626l18.024-2.789l0.515-0.078 c-9.777,28.388-23.296,46.729-36.068,58.524c-7.943,7.357-15.602,12.173-21.887,15.292 c-0.414,0.209-0.821,0.409-1.228,0.6c-1.012,0.487-1.993,0.921-2.925,1.319l-12.055,0.631 c-0.165-0.561-0.322-1.115-0.471-1.677c-0.103-0.352-0.198-0.704-0.285-1.057c-0.135-0.461-0.253-0.931-0.371-1.393 c-14.246-54.896,3.708-98.683,27.16-129.896c0.063-0.105,0.143-0.203,0.231-0.31 c8.161-10.831,16.988-20.148,25.337-27.875l5.329,13.57l0.766-19.01c14.544-12.56,26.64-19.887,29.612-21.617 C746.881,254.392,747.121,254.261,747.121,254.261z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "747.549,254.46 747.15,255.297 722.395,307.13 721.949,308.047 715.203,322.18  714.973,322.652 693.453,367.706 693.422,367.767 658.355,441.194 657.826,442.293 656.99,444.038 655.938,444.093  656.765,442.349 657.985,439.801 692.591,367.343 693.236,365.999 746.419,254.663 746.711,254.053  "
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 711.777,
    y: 311.812,
    transform: "matrix(0.8239 -0.5667 0.5667 0.8239 -48.3174 468.94)",
    style: {
      fill: "#FFFFFF"
    },
    width: 37.255,
    height: 0.81
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 719.32,
    y: 299.279,
    transform: "matrix(0.8239 -0.5667 0.5667 0.8239 -40.6068 468.6717)",
    style: {
      fill: "#FFFFFF"
    },
    width: 29.202,
    height: 0.81
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 688.881,
    y: 309.334,
    transform: "matrix(0.9917 -0.1286 0.1286 0.9917 -37.8262 91.4344)",
    style: {
      fill: "#FFFFFF"
    },
    width: 0.81,
    height: 58.727
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAC8F3"
    },
    d: "M654.265,453.343c0,0,28.573,13.5,69.222-10.737l-13.181-6.255l21.516,0.864 c15.865-11.099,33.279-28.016,51.357-53.473l-5.03-2.383l6.523,0.258c3.047-4.352,6.114-8.951,9.194-13.81 c0,0-11.937-1.059-29.002,0.915l-8.76,11.861l2.483-11.016C723.692,374.862,672.893,393.144,654.265,453.343z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 640.876,
    y: 408.783,
    transform: "matrix(0.8634 -0.5046 0.5046 0.8634 -107.7094 420.7425)",
    style: {
      fill: "#FFFFFF"
    },
    width: 164.212,
    height: 0.915
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 766.682,
    y: 380.564,
    transform: "matrix(0.1025 -0.9947 0.9947 0.1025 299.7382 1113.7588)",
    style: {
      fill: "#FFFFFF"
    },
    width: 0.849,
    height: 20.404
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 758.647,
    y: 385.296,
    transform: "matrix(0.1754 -0.9845 0.9845 0.1754 234.7539 1074.917)",
    style: {
      fill: "#FFFFFF"
    },
    width: 0.85,
    height: 24.043
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M687.665,401.233l-0.713-0.801c11.9-10.575,26.387-18.823,43.059-24.514l0.347,1.016 C713.822,382.577,699.458,390.752,687.665,401.233z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AADE5"
    },
    d: "M403.753,333.542c0.049,0.345,0.096,0.681,0.145,1.026 c5.874,42.138,15.714,74.092,27.309,98.326l23.883,9.774l-18.237,0.261l-0.521,0.009 c14.382,26.356,30.774,42.182,45.337,51.678c9.06,5.927,17.416,9.396,24.133,11.421c0.444,0.137,0.878,0.266,1.311,0.387 c1.079,0.311,2.119,0.575,3.104,0.811l11.991-1.392c0.069-0.581,0.131-1.153,0.184-1.732 c0.043-0.364,0.078-0.728,0.105-1.09c0.056-0.477,0.094-0.96,0.133-1.435c4.876-56.504-20.139-96.678-48.476-123.535 c-0.079-0.093-0.174-0.176-0.279-0.267c-9.855-9.315-20.115-17.027-29.637-23.251l-2.988,14.269l-3.931-18.615 c-16.437-9.954-29.587-15.158-32.806-16.367C404.011,333.632,403.753,333.542,403.753,333.542z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "403.365,333.81 403.898,334.569 436.963,381.539 437.555,382.368  446.568,395.176 446.874,395.603 475.617,436.429 475.658,436.484 522.496,503.022 523.202,504.018 524.317,505.599  525.364,505.477 524.257,503.895 522.629,501.587 476.405,435.927 475.546,434.71 404.512,333.822 404.123,333.268  "
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 429.511,
    y: 369.264,
    transform: "matrix(0.4211 -0.907 0.907 0.4211 -102.9449 614.4899)",
    style: {
      fill: "#FFFFFF"
    },
    width: 0.81,
    height: 37.255
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 423.95,
    y: 361.521,
    transform: "matrix(0.4211 -0.907 0.907 0.4211 -95.4888 602.6329)",
    style: {
      fill: "#FFFFFF"
    },
    width: 0.81,
    height: 29.202
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 474.475,
    y: 377.768,
    transform: "matrix(0.9992 -0.0389 0.0389 0.9992 -15.4708 18.7719)",
    style: {
      fill: "#FFFFFF"
    },
    width: 0.81,
    height: 58.727
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BAC8F3"
    },
    d: "M528.558,514.317c0,0-25.916,18.083-70.043,0.976l11.951-8.369l-21.069,4.446 c-17.497-8.293-37.491-22.063-59.568-44.143l4.562-3.19l-6.388,1.344c-3.731-3.781-7.523-7.804-11.371-12.08 c0,0,11.592-3.038,28.747-3.942l10.618,10.232l-4.288-10.446C446.997,448.535,500.136,458.076,528.558,514.317z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 452.983,
    y: 400.206,
    transform: "matrix(0.3533 -0.9355 0.9355 0.3533 -157.9699 736.1046)",
    style: {
      fill: "#FFFFFF"
    },
    width: 0.914,
    height: 164.212
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.647,
    y: 471.044,
    transform: "matrix(0.9636 -0.2673 0.2673 0.9636 -111.2045 125.8832)",
    style: {
      fill: "#FFFFFF"
    },
    width: 20.404,
    height: 0.849
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 403.844,
    y: 476.16,
    transform: "matrix(0.9414 -0.3374 0.3374 0.9414 -136.4161 168.2632)",
    style: {
      fill: "#FFFFFF"
    },
    width: 24.043,
    height: 0.85
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M486.923,468.518l0.569-0.909c-13.499-8.439-29.16-14.151-46.549-16.977l-0.172,1.059 C458.018,454.493,473.546,460.154,486.923,468.518z"
  })))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#446BD0"
    },
    d: "M534.254,540.518h-28.913c-9.413,0-17.148-7.325-17.537-16.601l-16.309-284.522 c-0.411-9.836,7.557-18.027,17.537-18.027h33.341L534.254,540.518z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE8FF"
    },
    d: "M677.053,239.395l-8.54,284.522c-0.389,9.277-8.124,16.601-17.537,16.601H523.141 c-9.413,0-20.5-7.325-20.889-16.601l-8.529-284.522c-0.411-9.836,7.557-18.027,17.537-18.027h148.255 C669.496,221.368,677.464,229.559,677.053,239.395z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5A9F"
    },
    d: "M529.016,241.038h-6.848c-0.949,0-1.798,0.38-2.413,1.005c-0.625,0.626-1.005,1.475-1.005,2.424 c0,1.888,1.531,3.418,3.418,3.418h6.848h111.798h6.848c0.949,0,1.798-0.38,2.413-1.005c0.626-0.614,1.005-1.463,1.005-2.413 c0-1.888-1.531-3.43-3.418-3.43h-6.848H529.016z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M646.254,353.016H524.522c-2.324,0-4.233-1.837-4.322-4.16l-3.021-79.196 c-0.094-2.451,1.868-4.49,4.322-4.49h127.774c2.453,0,4.415,2.038,4.322,4.49l-3.021,79.196 C650.487,351.179,648.578,353.016,646.254,353.016z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#647CE2"
    },
    d: "M554.864,406.494H536.04c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C560.854,403.812,558.172,406.494,554.864,406.494z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#647CE2"
    },
    d: "M554.864,440.007H536.04c-3.308,0-5.99-2.682-5.99-5.99v-8.556 c0-3.308,2.682-5.989,5.99-5.989h18.824c3.308,0,5.99,2.682,5.99,5.989v8.556 C560.854,437.325,558.172,440.007,554.864,440.007z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#647CE2"
    },
    d: "M554.864,473.52H536.04c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C560.854,470.838,558.172,473.52,554.864,473.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5A9F"
    },
    d: "M554.864,507.032H536.04c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C560.854,504.351,558.172,507.032,554.864,507.032z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#647CE2"
    },
    d: "M593.963,406.494h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C599.952,403.812,597.271,406.494,593.963,406.494z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#647CE2"
    },
    d: "M593.963,440.007h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556 c0-3.308,2.682-5.989,5.99-5.989h18.824c3.308,0,5.99,2.682,5.99,5.989v8.556 C599.952,437.325,597.271,440.007,593.963,440.007z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#647CE2"
    },
    d: "M593.963,473.52h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C599.952,470.838,597.271,473.52,593.963,473.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#647CE2"
    },
    d: "M593.963,507.032h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C599.952,504.351,597.271,507.032,593.963,507.032z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#647CE2"
    },
    d: "M633.061,406.494h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C639.05,403.812,636.369,406.494,633.061,406.494z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#647CE2"
    },
    d: "M633.061,440.007h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556 c0-3.308,2.682-5.989,5.99-5.989h18.824c3.308,0,5.99,2.682,5.99,5.989v8.556 C639.05,437.325,636.369,440.007,633.061,440.007z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#647CE2"
    },
    d: "M633.061,473.52h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C639.05,470.838,636.369,473.52,633.061,473.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5A9F"
    },
    d: "M633.061,507.032h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C639.05,504.351,636.369,507.032,633.061,507.032z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D92F0"
    },
    d: "M560.45,406.494h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C566.439,403.812,563.758,406.494,560.45,406.494z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D92F0"
    },
    d: "M560.45,440.007h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556 c0-3.308,2.682-5.989,5.99-5.989h18.824c3.308,0,5.99,2.682,5.99,5.989v8.556 C566.439,437.325,563.758,440.007,560.45,440.007z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D92F0"
    },
    d: "M560.45,473.52h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C566.439,470.838,563.758,473.52,560.45,473.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5A9F"
    },
    d: "M560.45,507.032h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C566.439,504.351,563.758,507.032,560.45,507.032z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D92F0"
    },
    d: "M599.548,406.494h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C605.537,403.812,602.856,406.494,599.548,406.494z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D92F0"
    },
    d: "M599.548,440.007h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556 c0-3.308,2.682-5.989,5.99-5.989h18.824c3.308,0,5.99,2.682,5.99,5.989v8.556 C605.537,437.325,602.856,440.007,599.548,440.007z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D92F0"
    },
    d: "M599.548,473.52h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C605.537,470.838,602.856,473.52,599.548,473.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D92F0"
    },
    d: "M599.548,507.032h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C605.537,504.351,602.856,507.032,599.548,507.032z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D92F0"
    },
    d: "M638.646,406.494h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C644.636,403.812,641.954,406.494,638.646,406.494z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D92F0"
    },
    d: "M638.646,440.007h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556 c0-3.308,2.682-5.989,5.99-5.989h18.824c3.308,0,5.99,2.682,5.99,5.989v8.556 C644.636,437.325,641.954,440.007,638.646,440.007z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D92F0"
    },
    d: "M638.646,473.52h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C644.636,470.838,641.954,473.52,638.646,473.52z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5A9F"
    },
    d: "M638.646,507.032h-18.824c-3.308,0-5.99-2.682-5.99-5.99v-8.556c0-3.308,2.682-5.99,5.99-5.99 h18.824c3.308,0,5.99,2.682,5.99,5.99v8.556C644.636,504.351,641.954,507.032,638.646,507.032z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M560.45,407.052h-18.825c-3.611,0-6.548-2.937-6.548-6.548v-8.557 c0-3.611,2.937-6.548,6.548-6.548h18.825c3.611,0,6.548,2.937,6.548,6.548v8.557 C566.997,404.116,564.061,407.052,560.45,407.052z M541.625,386.517c-2.995,0-5.431,2.436-5.431,5.43v8.557 c0,2.995,2.436,5.431,5.431,5.431h18.825c2.995,0,5.43-2.436,5.43-5.431v-8.557c0-2.995-2.436-5.43-5.43-5.43H541.625z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M560.45,440.565h-18.825c-3.611,0-6.548-2.937-6.548-6.548v-8.557 c0-3.611,2.937-6.548,6.548-6.548h18.825c3.611,0,6.548,2.937,6.548,6.548v8.557 C566.997,437.629,564.061,440.565,560.45,440.565z M541.625,420.03c-2.995,0-5.431,2.436-5.431,5.431v8.557 c0,2.994,2.436,5.43,5.431,5.43h18.825c2.995,0,5.43-2.436,5.43-5.43v-8.557c0-2.995-2.436-5.431-5.43-5.431H541.625z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M560.45,474.078h-18.825c-3.611,0-6.548-2.937-6.548-6.548v-8.557 c0-3.611,2.937-6.548,6.548-6.548h18.825c3.611,0,6.548,2.937,6.548,6.548v8.557 C566.997,471.141,564.061,474.078,560.45,474.078z M541.625,453.543c-2.995,0-5.431,2.436-5.431,5.431v8.557 c0,2.995,2.436,5.43,5.431,5.43h18.825c2.995,0,5.43-2.436,5.43-5.43v-8.557c0-2.995-2.436-5.431-5.43-5.431H541.625z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M560.45,507.591h-18.825c-3.611,0-6.548-2.937-6.548-6.548v-8.557 c0-3.611,2.937-6.548,6.548-6.548h18.825c3.611,0,6.548,2.937,6.548,6.548v8.557 C566.997,504.654,564.061,507.591,560.45,507.591z M541.625,487.055c-2.995,0-5.431,2.436-5.431,5.431v8.557 c0,2.995,2.436,5.431,5.431,5.431h18.825c2.995,0,5.43-2.436,5.43-5.431v-8.557c0-2.995-2.436-5.431-5.43-5.431H541.625z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M599.548,407.052h-18.825c-3.611,0-6.548-2.937-6.548-6.548v-8.557 c0-3.611,2.937-6.548,6.548-6.548h18.825c3.611,0,6.548,2.937,6.548,6.548v8.557 C606.096,404.116,603.159,407.052,599.548,407.052z M580.723,386.517c-2.995,0-5.431,2.436-5.431,5.43v8.557 c0,2.995,2.436,5.431,5.431,5.431h18.825c2.995,0,5.43-2.436,5.43-5.431v-8.557c0-2.995-2.436-5.43-5.43-5.43H580.723z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M599.548,440.565h-18.825c-3.611,0-6.548-2.937-6.548-6.548v-8.557 c0-3.611,2.937-6.548,6.548-6.548h18.825c3.611,0,6.548,2.937,6.548,6.548v8.557 C606.096,437.629,603.159,440.565,599.548,440.565z M580.723,420.03c-2.995,0-5.431,2.436-5.431,5.431v8.557 c0,2.994,2.436,5.43,5.431,5.43h18.825c2.995,0,5.43-2.436,5.43-5.43v-8.557c0-2.995-2.436-5.431-5.43-5.431H580.723z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M599.548,474.078h-18.825c-3.611,0-6.548-2.937-6.548-6.548v-8.557 c0-3.611,2.937-6.548,6.548-6.548h18.825c3.611,0,6.548,2.937,6.548,6.548v8.557 C606.096,471.141,603.159,474.078,599.548,474.078z M580.723,453.543c-2.995,0-5.431,2.436-5.431,5.431v8.557 c0,2.995,2.436,5.43,5.431,5.43h18.825c2.995,0,5.43-2.436,5.43-5.43v-8.557c0-2.995-2.436-5.431-5.43-5.431H580.723z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M599.548,507.591h-18.825c-3.611,0-6.548-2.937-6.548-6.548v-8.557 c0-3.611,2.937-6.548,6.548-6.548h18.825c3.611,0,6.548,2.937,6.548,6.548v8.557 C606.096,504.654,603.159,507.591,599.548,507.591z M580.723,487.055c-2.995,0-5.431,2.436-5.431,5.431v8.557 c0,2.995,2.436,5.431,5.431,5.431h18.825c2.995,0,5.43-2.436,5.43-5.431v-8.557c0-2.995-2.436-5.431-5.43-5.431H580.723z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M638.646,407.052h-18.825c-3.611,0-6.548-2.937-6.548-6.548v-8.557 c0-3.611,2.937-6.548,6.548-6.548h18.825c3.611,0,6.548,2.937,6.548,6.548v8.557 C645.194,404.116,642.257,407.052,638.646,407.052z M619.821,386.517c-2.994,0-5.43,2.436-5.43,5.43v8.557 c0,2.995,2.436,5.431,5.43,5.431h18.825c2.995,0,5.43-2.436,5.43-5.431v-8.557c0-2.995-2.436-5.43-5.43-5.43H619.821z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M638.646,440.565h-18.825c-3.611,0-6.548-2.937-6.548-6.548v-8.557 c0-3.611,2.937-6.548,6.548-6.548h18.825c3.611,0,6.548,2.937,6.548,6.548v8.557 C645.194,437.629,642.257,440.565,638.646,440.565z M619.821,420.03c-2.994,0-5.43,2.436-5.43,5.431v8.557 c0,2.994,2.436,5.43,5.43,5.43h18.825c2.995,0,5.43-2.436,5.43-5.43v-8.557c0-2.995-2.436-5.431-5.43-5.431H619.821z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M638.646,474.078h-18.825c-3.611,0-6.548-2.937-6.548-6.548v-8.557 c0-3.611,2.937-6.548,6.548-6.548h18.825c3.611,0,6.548,2.937,6.548,6.548v8.557 C645.194,471.141,642.257,474.078,638.646,474.078z M619.821,453.543c-2.994,0-5.43,2.436-5.43,5.431v8.557 c0,2.995,2.436,5.43,5.43,5.43h18.825c2.995,0,5.43-2.436,5.43-5.43v-8.557c0-2.995-2.436-5.431-5.43-5.431H619.821z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M638.646,507.591h-18.825c-3.611,0-6.548-2.937-6.548-6.548v-8.557 c0-3.611,2.937-6.548,6.548-6.548h18.825c3.611,0,6.548,2.937,6.548,6.548v8.557 C645.194,504.654,642.257,507.591,638.646,507.591z M619.821,487.055c-2.994,0-5.43,2.436-5.43,5.431v8.557 c0,2.995,2.436,5.431,5.43,5.431h18.825c2.995,0,5.43-2.436,5.43-5.431v-8.557c0-2.995-2.436-5.431-5.43-5.431H619.821z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5A9F"
    },
    d: "M635.447,541.268H523.141c-9.67,0-21.229-7.565-21.638-17.319l-8.529-284.531 c-0.206-4.907,1.568-9.582,4.993-13.153c3.492-3.641,8.213-5.646,13.293-5.646h148.255c5.081,0,9.802,2.005,13.293,5.646 c3.426,3.571,5.199,8.246,4.993,13.162l-0.465,15.524l-1.5-0.045l0.466-15.533c0.189-4.513-1.436-8.796-4.576-12.07 c-3.206-3.343-7.543-5.184-12.211-5.184H511.26c-4.668,0-9.005,1.841-12.211,5.184c-3.14,3.273-4.765,7.557-4.577,12.061 l8.529,284.531c0.374,8.936,11.133,15.873,20.139,15.873h112.307V541.268z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 590.037,
    y: 380.585,
    transform: "matrix(0.0299 -0.9996 0.9996 0.0299 271.4984 1042.4167)",
    style: {
      fill: "#3F5A9F"
    },
    width: 165.51,
    height: 1.501
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M640.767,186.308v61.574H529.159v-61.574c-0.268-4.245-2.212-8.043-5.15-10.78 c-2.949-2.737-6.915-4.413-11.216-4.413h111.609c4.312,0,8.267,1.676,11.216,4.413S640.499,182.063,640.767,186.308z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M529.159,186.308h-32.742c0.268-4.245,2.212-8.043,5.161-10.78 c2.949-2.737,6.915-4.413,11.216-4.413c4.301,0,8.267,1.676,11.216,4.413C526.947,178.265,528.891,182.063,529.159,186.308z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M641.268,248.382H528.659v-62.074c-0.25-3.939-2.023-7.649-4.991-10.415 c-2.972-2.758-6.835-4.278-10.875-4.278v-1h111.609c4.293,0,8.396,1.614,11.555,4.545c3.156,2.929,5.041,6.876,5.31,11.115 l0.001,0.032V248.382z M529.659,247.382h110.609v-61.058c-0.256-3.977-2.027-7.68-4.99-10.43 c-2.974-2.759-6.836-4.279-10.875-4.279H518.536c2.133,0.768,4.11,1.966,5.813,3.545c3.157,2.941,5.042,6.889,5.309,11.115 L529.659,247.382z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M647.662,248.386H522.169c-2.161,0-3.919-1.758-3.919-3.918c0-1.048,0.409-2.035,1.152-2.778 c0.728-0.742,1.712-1.152,2.767-1.152h6.848v1h-6.848c-0.784,0-1.515,0.304-2.056,0.855c-0.557,0.558-0.862,1.293-0.862,2.074 c0,1.609,1.309,2.918,2.919,2.918h125.494c0.784,0,1.515-0.304,2.057-0.856c0.558-0.548,0.862-1.279,0.862-2.063 c0-1.615-1.31-2.93-2.919-2.93h-6.848v-1h6.848c2.161,0,3.919,1.763,3.919,3.93c0,1.054-0.41,2.038-1.155,2.77 C649.7,247.976,648.717,248.386,647.662,248.386z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F49B51"
    },
    d: "M652.416,544.849c0,2.766,20.316,5.017,45.371,5.017c25.055,0,45.371-2.251,45.371-5.017 c0-0.054-0.011-0.096-0.022-0.15v-13.562h-90.689v13.53C652.426,544.731,652.416,544.784,652.416,544.849z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCC659"
    },
    cx: 697.789,
    cy: 531.261,
    rx: 45.369,
    ry: 5.017
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F49B51"
    },
    d: "M641.695,528.486c0,2.766,20.316,5.017,45.371,5.017c25.055,0,45.371-2.251,45.371-5.017 c0-0.054-0.011-0.096-0.022-0.15v-13.562h-90.689v13.53C641.705,528.368,641.695,528.422,641.695,528.486z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCC659"
    },
    cx: 687.068,
    cy: 514.898,
    rx: 45.369,
    ry: 5.017
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F49B51"
    },
    d: "M652.416,512.123c0,2.766,20.316,5.017,45.371,5.017c25.055,0,45.371-2.251,45.371-5.017 c0-0.054-0.011-0.097-0.022-0.15v-13.562h-90.689v13.53C652.426,512.005,652.416,512.059,652.416,512.123z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCC659"
    },
    cx: 697.789,
    cy: 498.535,
    rx: 45.369,
    ry: 5.017
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M697.782,550.399c18.454,0,45.908-1.479,45.908-5.554h-1.072 c0,1.564-15.399,4.482-44.836,4.482c-1.07,0-2.132-0.004-3.183-0.013l-0.008,1.072 C695.644,550.395,696.71,550.399,697.782,550.399z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M679.795,549.989l0.05-1.07c-4.594-0.221-8.806-0.521-12.521-0.895l-0.107,1.066 C670.95,549.465,675.181,549.768,679.795,549.989z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M715.69,532.83c17.05-1.552,17.05-3.701,17.05-4.408h-1.072 c0,0.522-2.888,2.14-16.074,3.34L715.69,532.83z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M686.832,533.975c5.101,0,10.11-0.093,14.889-0.276l-0.042-1.072 c-8.535,0.329-17.971,0.367-26.765,0.101l-0.031,1.072C678.777,533.916,682.797,533.975,686.832,533.975z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M663.62,533.27l0.071-1.07c-4.838-0.318-9.058-0.73-12.542-1.223l-0.151,1.062 C654.509,532.535,658.756,532.949,663.62,533.27z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M728.294,502.808c15.121-1.542,15.121-3.49,15.121-4.222h-1.072 c0,0.017-0.385,1.752-14.158,3.157L728.294,502.808z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M697.508,504.139c5.216,0,10.318-0.096,15.161-0.287l-0.042-1.072 c-4.83,0.19-9.917,0.287-15.119,0.287c-9.311,0-18.253-0.31-25.86-0.896l-0.082,1.068 C679.2,503.828,688.17,504.139,697.508,504.139z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F49B51"
    },
    d: "M636.334,495.76c0,2.766,20.316,5.017,45.371,5.017c25.055,0,45.371-2.251,45.371-5.017 c0-0.054-0.011-0.096-0.021-0.15v-13.562h-90.689v13.53C636.345,495.642,636.334,495.696,636.334,495.76z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCC659"
    },
    cx: 681.707,
    cy: 482.172,
    rx: 45.369,
    ry: 5.017
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F49B51"
    },
    d: "M644.753,482.172c0,1.864,16.545,3.374,36.954,3.374c20.409,0,36.954-1.511,36.954-3.374 c0-1.864-16.545-3.374-36.954-3.374C661.298,478.798,644.753,480.309,644.753,482.172z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 604.589,
    y: 198.181,
    style: {
      fill: "#E1EAFF"
    },
    width: 24.255,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 544.589,
    y: 198.181,
    style: {
      fill: "#E1EAFF"
    },
    width: 48.766,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 572.674,
    y: 211.181,
    style: {
      fill: "#E1EAFF"
    },
    width: 56.17,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 544.589,
    y: 211.181,
    style: {
      fill: "#E1EAFF"
    },
    width: 21.191,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 595.397,
    y: 225.181,
    style: {
      fill: "#E1EAFF"
    },
    width: 22.979,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 544.589,
    y: 225.181,
    style: {
      fill: "#E1EAFF"
    },
    width: 41.106,
    height: 3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 553.574,
    y: 352.267,
    style: {
      fill: "#3F5A9F"
    },
    width: 30.414,
    height: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F5A9F"
    },
    d: "M646.254,353.767h-50.467v-1.5h50.467c1.93,0,3.499-1.511,3.573-3.439l2.645-69.32l1.498,0.058 l-2.644,69.319C651.221,351.622,648.993,353.767,646.254,353.767z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC659"
    },
    d: "M364.973,247.945c-16.655-3.321-32.848,7.492-36.17,24.154 c-3.321,16.655,7.491,32.854,24.154,36.17c16.655,3.321,32.855-7.491,36.17-24.154 C392.448,267.46,381.635,251.267,364.973,247.945z M383.244,282.945c-1.292,6.483-5.033,12.076-10.536,15.747 c-5.496,3.673-12.092,4.987-18.581,3.694c-13.382-2.669-22.105-15.727-19.435-29.116c1.292-6.483,5.027-12.077,10.53-15.748 c5.304-3.542,11.637-4.889,17.903-3.816c0.228,0.039,0.45,0.083,0.677,0.129c13.169,2.62,21.813,15.298,19.563,28.445 C383.326,282.502,383.288,282.724,383.244,282.945z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F49B51"
    },
    d: "M383.365,282.28c-0.038,0.222-0.076,0.444-0.12,0.665c-1.292,6.483-5.033,12.076-10.536,15.748 c-5.496,3.673-12.092,4.987-18.582,3.694c-13.383-2.669-22.106-15.728-19.435-29.117c1.292-6.483,5.027-12.077,10.53-15.749 c5.304-3.542,11.638-4.889,17.904-3.816c0.229,0.039,0.45,0.084,0.677,0.129C376.971,256.453,385.615,269.133,383.365,282.28z "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCC659"
    },
    d: "M354.227,296.505l0.786-4.591c-2.629-0.496-5.216-1.782-6.612-3.19l1.612-2.859 c1.45,1.371,3.665,2.639,6.211,3.075c3.228,0.552,5.728-0.938,6.172-3.529c0.428-2.5-1.08-4.349-4.211-6.288 c-4.326-2.612-6.831-5.193-6.155-9.148c0.646-3.772,3.818-6.178,8.116-6.143l0.786-4.591l2.818,0.482l-0.755,4.409 c2.712,0.557,4.451,1.604,5.637,2.602l-1.65,2.805c-0.861-0.709-2.554-2.027-5.463-2.525c-3.5-0.599-5.176,1.266-5.488,3.085 c-0.405,2.364,1.075,3.833,4.75,6.147c4.355,2.71,6.314,5.479,5.622,9.524c-0.615,3.591-3.69,6.527-8.504,6.499l-0.809,4.727 L354.227,296.505z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M383.407,276.006c-0.017-0.207-0.04-0.414-0.063-0.621c-0.79-7.021-4.564-13.334-10.357-17.361 l0.383-0.552c5.952,4.138,9.829,10.624,10.636,17.796c0.028,0.255,0.052,0.468,0.07,0.682L383.407,276.006z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M372.987,258.024c-4.658-3.239-10.334-4.756-15.982-4.275l-0.057-0.668 c5.805-0.496,11.636,1.065,16.423,4.392L372.987,258.024z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M378.252,294.249l-0.512-0.432c2.094-2.482,3.649-5.288,4.619-8.339l0.639,0.204 C382,288.817,380.403,291.7,378.252,294.249z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M382.553,258.94c-1.991-2.453-4.337-4.571-6.973-6.293l0.394-0.603 c2.698,1.763,5.099,3.931,7.137,6.442L382.553,258.94z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E4882"
    },
    d: "M371.718,306.493l-0.295-0.656c8.95-4.03,15.436-12.175,17.351-21.788 c1.19-5.974,0.578-12.088-1.771-17.68l0.663-0.279c2.404,5.725,3.031,11.984,1.813,18.1 C387.518,294.03,380.879,302.368,371.718,306.493z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9992 -0.0398 0.0398 0.9992 -11.8341 23.474)",
    style: {
      fill: "#6D92F0"
    },
    cx: 582.961,
    cy: 308.614,
    rx: 28.549,
    ry: 28.549
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "581.89,323.177 568.795,309.707 570.229,308.313 581.331,319.733 595.614,290.131  597.415,291  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6A6"
    },
    d: "M339.021,261.327c2.807,1.426,4.738,3.614,6.058,6.355l0,0 c1.32-2.741,3.259-4.941,6.066-6.367l0,0c-2.807-1.426-4.746-3.614-6.066-6.355l0,0 C343.759,257.7,341.828,259.901,339.021,261.327z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE6A6"
    },
    d: "M363.635,300.454c1.631,0.829,2.753,2.1,3.521,3.693l0,0c0.767-1.593,1.894-2.871,3.525-3.7 l0,0c-1.631-0.829-2.758-2.1-3.525-3.693l0,0C366.389,298.347,365.267,299.626,363.635,300.454z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPay);
export default __webpack_public_path__ + "static/media/ImgPay.46a081bea302429e5aba5960cb21f53a.svg";
export { ForwardRef as ReactComponent };